'use client'

import { BlockNoteSchema } from '@blocknote/core'
import { BlockNoteView } from '@blocknote/mantine'
import '@blocknote/mantine/style.css'
import { useCreateBlockNote } from '@blocknote/react'
import {
  multiColumnDropCursor,
  withMultiColumn,
} from '@blocknote/xl-multi-column'

export default function CharacterDescription({
  description,
  classNameOverride,
}: {
  description: string
  classNameOverride?: string
}) {
  const parseDescription =
    description === '[{}]' || description === ''
      ? `[{
      "type": "paragraph",
      "content": "",
      "attributes": {}
    }]`
      : description

  const editorView = useCreateBlockNote({
    initialContent: JSON.parse(parseDescription),
    schema: withMultiColumn(BlockNoteSchema.create()),
    dropCursor: multiColumnDropCursor,
  })

  return (
    <BlockNoteView
      editable={false}
      editor={editorView}
      autoFocus={false}
      theme={'light'}
      formattingToolbar={false}
      className={classNameOverride ?? 'container h-auto w-full bg-white'}
    />
  )
}
